import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useAuth, useProtectedContent } from '../../../../context/AuthContext'
import callAPI from '../../../../helpers/callAPI'
import moment from 'moment'

const AffiliateDropdown = (props) => {
    const auth = useAuth()
    const showSegmentReport = useProtectedContent(auth.permissions, 'affiliate_segment_edit')
    const showDormantReport = useProtectedContent(auth.permissions, 'affiliate_dormant_report')
    const showDormantBalanceReport = useProtectedContent(auth.permissions, 'affiliate_dormant_balance_report')
    const showPerformanceComparison = useProtectedContent(auth.permissions, 'affiliate_performance_comparison')
    const showBonusCandidates = useProtectedContent(auth.permissions, 'affiliate_bonus_candidates')
    const showPaymentTotals = useProtectedContent(auth.permissions, 'affiliate_payment_totals')
    const showCreateNotification = useProtectedContent(auth.permissions, 'affiliate_notification')
    const showTopAffiliates = useProtectedContent(auth.permissions, 'affiliates_top')
    const showAffiliateSearches = useProtectedContent(auth.permissions, 'affiliates_searches')
    const showPitchReport = useProtectedContent(auth.permissions, 'affiliate_pitch_report')
    const showResources = useProtectedContent(auth.permissions, 'affiliate_resources')
    const showIncompleteApps = useProtectedContent(auth.permissions, 'affiliate_incomplete_apps')
    const showDirectLinkSettings = useProtectedContent(auth.permissions, 'direct_link_settings')
    // const showPerformanceBonusReport = useProtectedContent(auth.permissions, 'affiliate_performance_bonus_report')


    const [dropdownOpen, setDropdownOpen] = useState(false)

    const toggle = () => {
        setDropdownOpen(!dropdownOpen)
    }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle tag="a" onClick={toggle} data-toggle="dropdown" aria-expanded={dropdownOpen} className="nav-link dropdown-toggle">
                Affiliates
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-dark " style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <Link className="dropdown-item" to="/affiliates/search" onClick={toggle}>
                    Search Affiliates
                </Link>
                {showCreateNotification && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/affiliateNews" onClick={toggle}>
                            Create Affiliate Notification
                        </Link>
                    </>
                )}
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/affiliates/mailer" onClick={toggle}>
                    Affiliate Mailer
                </Link>

                <DropdownItem divider className="m-0 dropdown-separator" />

                <Link className="dropdown-item" to={`/reports/stats/affiliates${['AM_JUNIOR', 'AM_SENIOR', 'AM_JR_TEMLEAD'].includes(auth.user.role) ? `?adminId=${auth.user.id}&withAvatar=true` : ''}`} onClick={toggle}>
                    Affiliate Earnings
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/reports/affiliateTrend" onClick={toggle}>
                    Affiliate Trend Report
                </Link>
                {showSegmentReport && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/segmentReport" onClick={toggle}>
                            Segment Report
                        </Link>
                    </>
                )}
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/affiliates?status=A" onClick={toggle}>
                    Newest Affiliates
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                {showTopAffiliates && (
                    <>
                        <Link className="dropdown-item" to="/affiliates/top" onClick={toggle}>
                            Top Affiliates
                        </Link>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    </>
                )}
                <Link className="dropdown-item" to="/affiliates/topByCountry" onClick={toggle}>
                    Top By Country
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/affiliates/marginByPriority" onClick={toggle}>
                    Margin By Priority
                </Link>

                {showPitchReport && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to={`/affiliates/pitchReport${['AM_JUNIOR', 'AM_SENIOR', 'AM_JR_TEAMLEAD'].includes(auth.user.role) ? `?adminId=${auth.user.id}` : ''}`} onClick={toggle}>
                            Affiliate Pitch Report
                        </Link>
                    </>
                )}

                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/reports/custom/campaignPromiseReport" onClick={toggle}>
                    Campaign Promises Summary
                </Link>

                {showAffiliateSearches && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/searches" onClick={toggle}>
                            Search Affiliate Searches
                        </Link>
                    </>
                )}

                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/affiliates/byCategory" onClick={toggle}>
                        Affiliates By Category
                    </Link>
                </>

                <DropdownItem divider className="m-0 dropdown-separator" />
                <Link className="dropdown-item" to="/reports/affiliate_signup" onClick={toggle}>
                    Affiliate Health Report
                </Link>

                {showPerformanceComparison && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/performanceComparison" onClick={toggle}>
                            Affiliate Performance Comparison
                        </Link>
                    </>
                )}
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/affiliates/cancelled" onClick={toggle}>
                    Cancelled Affiliates Last 30 Days
                </Link>
                <DropdownItem divider className="m-0 dropdown-divider-dark" />
                <Link className="dropdown-item" to="/affiliates/trafficToday" onClick={toggle}>
                    Affiliate Traffic Today
                </Link>
                {showBonusCandidates && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/performanceBonus" onClick={toggle}>
                            Performance Bonus Candidates (old)
                        </Link>
                    </>
                )}
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to={`/affiliates/performanceBonusReport?startDate=${moment().add(-3, 'months').startOf('month').format('YYYY-MM-DD')}&endDate=${moment().format('YYYY-MM-DD')}`} onClick={toggle}>
                        Performance Bonus Report (new)
                    </Link>
                </>
                {showDormantReport && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/dormant" onClick={toggle}>
                            Dormant Affiliates
                        </Link>
                    </>
                )}
                {showDormantBalanceReport && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/dormant/balances" onClick={toggle}>
                            Dormant Balances
                        </Link>
                    </>
                )}
                <DropdownItem divider className="m-0 dropdown-separator" />
                <Link className="dropdown-item" to="/maxmoney" onClick={toggle}>
                    MaxMoney
                </Link>
                {showDirectLinkSettings && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/directLinkSettings" onClick={toggle}>
                            Affiliate Direct Link Settings
                        </Link>
                    </>
                )}
                {showResources && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/resources" onClick={toggle}>
                            Affiliate Portal Resource Page
                        </Link>
                    </>
                )}
                {showIncompleteApps && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/reportIncompleteApps" onClick={toggle}>
                            Incomplete Applications
                        </Link>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/affiliates/incompleteApps" onClick={toggle}>
                            Manage Incomplete Apps
                        </Link>
                    </>
                )}
                {showPaymentTotals && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/reports/affiliatePaymentTotals" onClick={toggle}>
                            Affiliate Payment Totals
                        </Link>
                    </>
                )}
                {showPaymentTotals && (
                    <>
                        <DropdownItem divider className="m-0 dropdown-divider-dark" />
                        <Link className="dropdown-item" to="/reports/affiliatemonthendbalances" onClick={toggle}>
                            Affiliate Month End Balances
                        </Link>
                    </>
                )}
                <>
                    <DropdownItem divider className="m-0 dropdown-divider-dark" />
                    <Link className="dropdown-item" to="/reports/reversals/affiliates" onClick={toggle}>
                        Affiliate Reversal Report
                    </Link>
                </>                          
            </DropdownMenu>
        </Dropdown>
    )
}

export default AffiliateDropdown
